module.exports = __webpack_public_path__ + "img/logo.d5430222.png";